import React from "react";

const ClassedElement = ( elementClassName, elementType, children, className, forwardRef, ...otherProps ) => {
	className = [elementClassName, className].filter((cn) => !!cn).join(" ");
	return React.createElement(elementType, { className, ref: forwardRef, ...otherProps }, children);
}

export default ClassedElement;